/**
 * 宠物学习模块（TEACH-PAGES-117，UI-2）：TA 的小动作、教学描述、一个小动作的页面（确认、本次学习、学习成果）。
 * 全屏页、不挂底栏，和 /me/look 同一类；入口在「我的」页（TeachEntry，属主 6c2b 同意后接进 MePage）。
 * 自动发现（app/modules.ts），不改 app/ 和 router。路由归类在 shared/session/householdContext.tsx 的 PET_BAR_ROUTES（报 I）。
 */
import { defineModule } from "@/shared/modules/types";
import { TeachDescribePage } from "./TeachDescribePage";
import { TeachHomePage } from "./TeachHomePage";
import { TeachOrderPage } from "./TeachOrderPage";

export default defineModule({
  id: "teach",
  bareRoutes: [
    { path: "me/moves", element: <TeachHomePage /> },
    { path: "me/moves/new", element: <TeachDescribePage /> },
    { path: "me/moves/:orderId", element: <TeachOrderPage /> },
  ],
});
